import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Heading, DataList, Button, Separator } from '@radix-ui/themes';
import { Pencil1Icon } from '@radix-ui/react-icons';
import GeneralInfoProfileForm from '../GeneralInfoProfileForm';

const GeneralInfo = () => {
    const user = useSelector((state) => state.user.details);
    const [isEditing, setIsEditing] = useState(false);

    return (
        <Flex direction="column" gap="4" align="start" width="100%">
            <Flex direction="row" justify="between" align="center" width="100%">
                <Heading size="2">General Information</Heading>
                <Button variant="ghost" onClick={() => setIsEditing(!isEditing)}>
                    <Pencil1Icon /> {isEditing ? 'Cancel' : 'Edit'}
                </Button>
            </Flex>

            {isEditing ? (
                <GeneralInfoProfileForm onClose={() => setIsEditing(false)} setIsEditing={setIsEditing} />
            ) : (
                <DataList.Root>
                    <DataList.Item>
                        <DataList.Label minWidth="100px">Firstname</DataList.Label>
                        <DataList.Value>{user.firstname}</DataList.Value>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.Label minWidth="100px">Lastname</DataList.Label>
                        <DataList.Value>{user.lastname}</DataList.Value>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.Label minWidth="100px">Email</DataList.Label>
                        <DataList.Value>{user.email ?? 'N/A'}</DataList.Value>
                    </DataList.Item>
                </DataList.Root>
            )}
        </Flex>
    );
};

export default GeneralInfo;
